// Helper to map orderstatus code to label
function getOrderStatusLabel(orderstatus) {
    //alert(orderstatus);
    switch (orderstatus) {
        case '3': return 'Placed';
        case '4': return 'Cooking';
        case '5': return 'Ready for delivery';
        case '6': return 'Out for delivery';
        case '7': return 'Completed';
        default: return 'N/A';
    }
}

function getOrderTypeLabel(order, type) {
    let orderSource = ""
    let orderType = ""
    var tableNameString = "";

    if (order.source === 'pos') {
        if (order.ordertype === '1' || order.ordertype === '2') {
            orderSource = 'Phone Order';
        } else if (order.ordertype === '3') {
            orderSource = 'Dine In';
        }
    }else if (order.source === 'table_order') {
        orderSource = "Table Order";
    } else {
        if(order.uber_order_id && order.tender==='ubereats'){
            orderSource = "Uber";
        }else{
            orderSource = "Website";
        }
    }
    
    if (order.ordertype === '1') {
        orderType = 'Take Away';
    } else if (order.ordertype === '2') {
        orderType = 'Delivery';
    } else if (order.ordertype === '3') {
        // orderType = 'Dine In';
    } else {
        orderType = 'N/A';
    }
    let tableName = [];
    if (order.tables.length > 0) {
        tableName = order.tables.map(el => el.name);
        tableNameString = tableName.toString();
    }

    // Use React elements instead of HTML strings
    const orderTypeElement = <small className="text-uppercase text-muted">{orderType}</small>;
    const tableNameElement = <small className="text-uppercase text-muted">{tableNameString}</small>;

    if (order.ordertype === '3') {
        return (
            <>
                {orderSource}
                <br />
                {tableNameElement}
            </>
        );
    } else {
        return (
            <>
                {orderSource}
                <br />
                {orderTypeElement}
            </>
        );
    }
}

function getOrderPaidLabel(order) {
    var paidtext = '';
    if (order.paid == 1) {
        var mode = '';
        if(order.paymode == 1){
            mode ='(CASH)';
        }else if(order.paymode== 2){
            mode ='(EFTPOS)';
        }else if(order.paymode==3 ){
            mode ='(ONLINE)';
        }
        paidtext = 'Paid'+mode;
    } else {
        //unpaidSelected = 'selected';
        paidtext = 'Unpaid';
    }
    return paidtext;
}

function getServerName(order) {
    let serverName = 'N/A';
    if (order.server) {
        serverName = order.server.first_name + ' ' + order.server.last_name;
    }
    return serverName;
}
const getOrderSourceLabel = (order) => {
    if (order.source === "pos") return "POS";
    if (order.source === "uber") return "Uber";
    if (order.source === "website") return "Website";
    if (order.source === "ai") return "Website";
    if (order.source === "table_order") return "NFC Table Order";
    return "--";
  };
  
export default getOrderStatusLabel;
export { getOrderTypeLabel, getOrderStatusLabel, getOrderPaidLabel, getServerName , getOrderSourceLabel};